export default __webpack_public_path__ + "static/media/defence.816c2fb5.png";